import * as React from 'react';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

// Styles
import { useTheme } from '@mui/material/styles';

import {
  MemberWaiverStatus
} from "../../interfaces";

interface WaiverFilterProps {
  handleChange: (option: string) => void;
  waivers: Array<MemberWaiverStatus>;
}

const WaiverFilter: React.FC<WaiverFilterProps> = (props) => {

  const [all, setAll] = React.useState<number>(0);
  const [accepted, setAccepted] = React.useState<number>(0);
  const [pending, setPending] = React.useState<number>(0);
  const [value, setValue] = React.useState<string>('99');

  // #region Styles

  const theme = useTheme();
  const styles = {
    root: {
      padding: theme.spacing(1, 0, 1, 0),
    },
  };

  // #endregion

  // #region Methods

  const calculateTotals = () => {
    setAll(props.waivers.length);
    setAccepted(props.waivers.filter(w => { return w.waiverStatusID === 1 }).length);
    setPending(props.waivers.filter(w => { return w.waiverStatusID === 2 }).length);
  }

  // #endregion

  // #region Event handlers

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };

  React.useEffect(() => {
    props.handleChange(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  React.useEffect(() => {
    calculateTotals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.waivers.length]);

  // #endregion

  return (
    <Box sx={styles.root}>
      <FormControl>
        <FormLabel>Filter</FormLabel>
        <RadioGroup
          defaultValue="99"
          name="waiverFilter"
          onChange={handleChange}
        >
          <FormControlLabel value="99" control={<Radio />} label={"All (" + all.toString() + ")"} />
          <FormControlLabel value="1" control={<Radio />} label={"Accepted (" + accepted.toString() + ")"} />
          <FormControlLabel value="2" control={<Radio />} label={"Pending (" + pending.toString() + ")"} />
        </RadioGroup>
      </FormControl>
    </Box>
  );
}

export default WaiverFilter;